import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { dateDiff } from '../../../Timestamp/functions';
import { CommentContext } from '../../CommentContext';
export function useButtonConditionals(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.canPostComment, canPostComment = _c === void 0 ? true : _c;
    var comment = useContext(CommentContext).comment;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var canEdit = comment.isAuthor &&
        dateDiff(new Date().toISOString(), comment.posted, 'days') === 0;
    return {
        showEditButton: (canPostComment || !isLoggedIn) && canEdit,
        showReplyButton: canPostComment || !isLoggedIn,
        // TODO: Referring to the doc comment below, separate the like counter from the like button?
        /**
         * We always show the like button because the like counter is part of it at the moment
         */
        showLikeButton: true,
        showAwardBadgeButton: !comment.isAuthor,
    };
}
//# sourceMappingURL=useButtonConditionals.js.map